import { MERCHANT_COMMERCIAL } from '../const';
import CustomTooltip from '../CustomToolTip';

export const commonFields = [
  {
    type: 'number',
    label: 'Min Amount',
    key: 'min_amount',
    disable: true,
    validator: () => {}
  },
  {
    type: 'number',
    label: 'Max Amount',
    key: 'max_amount',
    disable: true,
    validator: () => {}
  },
  // {
  //   type: 'text',
  //   label: 'Commerical Type',
  //   key: 'commercial_type',
  //   disable: true,
  //   validator: () => {}
  // },
  {
    type: 'number',
    label: <CustomTooltip label={MERCHANT_COMMERCIAL} />,
    key: 'commercial_value',
    warningText: 'Old',
    disable: true,
    validator: () => {}
  }
];

const baseRateField = [
  {
    type: 'number',
    label: 'Min Amount',
    key: 'min_amount',
    disable: true,
    validator: () => {}
  },
  {
    type: 'number',
    label: 'Max Amount',
    key: 'max_amount',
    disable: true,
    validator: () => {}
  },
  // {
  //   type: 'text',
  //   label: 'Base Rate Type',
  //   key: 'base_rate_type',
  //   disable: true,
  //   validator: () => {}
  // },
  {
    type: 'number',
    label: 'Charge',
    key: 'base_rate_value',
    warningText: 'Old',
    disable: true,
    validator: () => {}
  }
];

export const wireFields = {
  span: 6,
  default: {
    primary: commonFields,
    differential: commonFields
  },
  base_rate: {
    primary: baseRateField
  }
};
